(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            var data = response.data;
            // Le formulaire de connexion traite les demandes MFA et leurs erreurs.
            var isMfaResponse = (response.status === 401 || response.status === 503) && data && data.mfa_required === true;
            var isAccountResponse = response.status === 401 && (data === '' ||
                (data && typeof data.path === 'string' && data.path.indexOf('/api/account') === 0));
            if (!isMfaResponse && !isAccountResponse) {
                $rootScope.$emit('wamasysApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
